import { render, staticRenderFns } from "./LocaleGrid.vue?vue&type=template&id=35484bcf&"
import script from "./LocaleGrid.vue?vue&type=script&lang=js&"
export * from "./LocaleGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports